import React from "react";
import ProductListPage from "./ProductListPage";
import { api } from "../lib/api";
import { useShop } from "../lib/shop-context";

/**
 * Phase 30 — /para-ti
 * Phase 32 — scoped to the current shop.
 */
export default function ParaTi() {
  const shopCtx = useShop();
  const shop = shopCtx?.shop || "envio";
  return (
    <ProductListPage
      title="Para ti"
      subtitle="Recomendaciones personalizadas por MercaGo AI"
      testid="para-ti-page"
      authRequired
      emptyMessage="Aún no tenemos recomendaciones para ti. Añade productos a tu carrito y volvemos con sugerencias."
      fetchFn={() =>
        api
          .post("/ai/recommendations", { context: "home", shop })
          .then((r) => r.data?.products || [])
      }
    />
  );
}
